const rdcn = (translations) => translations?.rechargeDebitCreditNote || {}
const cs = (translations) => translations?.common || {}

export const getRechargeTypeList = (translations) => {
    const d = rdcn(translations)
    return [
    { id: 4, name: d.branchRecharge || 'Branch Recharge',idVal:'branchRecharge',nextId:'partyRecharge',prevId:'' },
    { id: 6, name: d.partyRecharge || 'Party Recharge',idVal:'partyRecharge',nextId:'maven',prevId:'branchRecharge'  },
    { id: 3, name: d.maven || 'Maven',idVal:'maven',nextId:'bkngDelQR',prevId:'partyRecharge'  },
    { id: 1, name: d.bookingDeliveryQr || 'Booking & Delivery QR',idVal:'bkngDelQR',nextId:'pos',prevId:'maven'  },
    { id: 2, name: d.pos || 'POS',idVal:'pos',nextId:'QRPaymentSettlementFor',prevId:'bkngDelQR'  },
]
}

export const getBankDetailsList = (translations) => {
    const d = rdcn(translations)
    return [
    { name: d.accountName || 'Account Name', type: "string", field: "accountName" },
    { name: d.accountNumber || 'Account Number', type: "number", field: "accountNumber" },
    { name: d.ifscCode || 'IFSC Code', type: "string", field: "IFSCCode" },
    { name: d.bankName || 'Bank Name', type: "string", field: "bankName" },
    { name: d.registeredMobNo || 'Registered Mob No', type: "number", field: "registeredMob" },
    { name: d.registeredEmailId || 'Registered Email ID', type: "string", field: "registeredEmailID" },
    { name: d.settlementDays || 'Settlement Days', type: "number", field: "settlementDays" },
    { name: d.transactionFee || 'Transaction Fee ', type: "number", field: "transactionFee" },
]
}

export const getQrPaymentSettlemntList = (translations) => {
    const d = rdcn(translations)
    const c = cs(translations)
    return [
    { id: 0, name: d.company || 'Comapny' },
    { id: 1, name: c.branch || 'Branch' },
]
}
